import React from 'react';
import { Home, Search, BookOpen, User } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

export const BottomNav: React.FC = () => {
  const location = useLocation();
  const { bgClass } = useTheme();
  
  const isActive = (path: string) => location.pathname === path;
  
  const navItems = [
    { icon: Home, label: 'Home', path: '/' },
    { icon: Search, label: 'Browse', path: '/search' },
    { icon: BookOpen, label: 'My Archive', path: '/library' },
    { icon: User, label: 'Profile', path: '/profile' },
  ];

  return (
    <nav className={`fixed bottom-0 left-0 right-0 z-50 border-t border-black/5 dark:border-white/5 ${bgClass} pb-safe pt-1`}>
      <div className="flex justify-around items-center h-14 max-w-lg mx-auto">
        {navItems.map((item) => (
          <Link 
            key={item.path} 
            to={item.path}
            className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive(item.path) ? 'text-brand-blue' : 'opacity-50'}`}
          >
            <item.icon size={20} strokeWidth={isActive(item.path) ? 2.5 : 2} />
            <span className="text-[10px] font-medium">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};
